import { RootState } from "../store";

export const busySelector = (state: RootState) => state.encode.busy;

export const errorSelector = (state: RootState) => state.encode.error;

export const outputSelector = (state: RootState) => state.encode.output;
